// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__GmLTR","alert":"SettungsInbox_alert__3ersa"};